import { createContext } from "react";

export const ActivatedNameContext = createContext(null);
